import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { Height } from "@mui/icons-material";
import { addChatWindow } from "../../Redux/Slice/dataSlice";
import { useDispatch } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "#fff",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",

  Height: 900,
};

const ConfirmationEscortModal = ({
  open,
  handleClose,
  handleSubmit,
  username,
  userId,
  onCloseMainModal,
  submitLatter,
}) => {
  const dispatch = useDispatch();
  const handalChatWindowOpen = () => {
    dispatch(addChatWindow({ userId, username }));
    onCloseMainModal();
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEnforceFocus
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.3)" },
      }}
    >
      <Box sx={style}>
        <Typography
          sx={{ color: "Black", fontSize: 30 }}
          variant="h5"
          fontWeight={700}
          gutterBottom
        >
          Wait!
        </Typography>
        <Typography variant="subtitle1" sx={{ color: "black" }} fontWeight={600} gutterBottom>
          {username} is Still Lost on Radar
        </Typography>
        <Typography variant="body2" sx={{ color: "black" }} mt={2}>
          Before leaving this page, you must submit a Wellbeing Check Report for {username}.
        </Typography>
        <Typography variant="body2" sx={{ color: "black" }} mt={1} mb={3}>
          Have you conducted a wellbeing check for this user?
        </Typography>
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            mb: 1,
            "&:hover": { backgroundColor: "#1565c0" },
            "&:active": { backgroundColor: "#1565c0" },
            "&:focus": { backgroundColor: "#1565c0" },
          }}
          onClick={handalChatWindowOpen}
        >
          Send a Message
        </Button>
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#2e7d32",
            color: "#fff",
            mb: 1,
            "&:hover": { backgroundColor: "#2e7d32" },
            "&:active": { backgroundColor: "#2e7d32" },
            "&:focus": { backgroundColor: "#2e7d32" },
          }}
          onClick={handleSubmit}
        >
          Yes, Proceed to Submit Report
        </Button>
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#d32f2f",
            color: "#fff",
            mb: 1,
            "&:hover": { backgroundColor: "#d32f2f" },
            "&:active": { backgroundColor: "#d32f2f" },
            "&:focus": { backgroundColor: "#d32f2f" },
          }}
          onClick={handleClose}
        >
          No, Take Me Back
        </Button>
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#eee30dff",
            color: "#000000ff",
            "&:hover": { backgroundColor: "#eee30dff" },
            "&:active": { backgroundColor: "#eee30dff" },
            "&:focus": { backgroundColor: "#eee30dff" },
          }}
          onClick={submitLatter}
        >
          SUBMIT LATER
        </Button>
      </Box>
    </Modal>
  );
};

export default ConfirmationEscortModal;
